// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AT8E","rootNoMargin":"styles_rootNoMargin__tvDKN"};